import { get, post, put } from "../helpers/api_helper";

const SERVICES_BASE_URL = "/shop/shop-merchant-services";
const USER_BASE_URL = "/users";
const PRODUCTS_BASE_URL = "/shop/products";

const STORE_BASE_URL = "/shop/service-store-branches";

// Initial refactored 👇
export const getAllServicesService = (params, rejectWithValue) =>
  get(`${SERVICES_BASE_URL}`, { params }, rejectWithValue);

export const getServiceDetailsByMerchantIdService = (id, rejectWithValue) =>
  get(`${SERVICES_BASE_URL}/${id}`, {}, rejectWithValue);

export const getServiceDetailsByMerchantIdAndMonthService = (
  params,
  rejectWithValue
) =>
  get(
    `${SERVICES_BASE_URL}/${params?.id}`,
    { params: { month: params?.month || "" } },
    rejectWithValue
  );

export const getServicesMaxPriceService = (params, rejectWithValue) =>
  get(`${PRODUCTS_BASE_URL}/max-price`, { params }, rejectWithValue);

export const updateUserGeolocationService = (payload, rejectWithValue) =>
  put(`${USER_BASE_URL}/set-location`, payload, {}, rejectWithValue);

// TO DO Refactoring 👇
export const getMerchantServiceService = (id, rejectWithValue) =>
  get(`${SERVICES_BASE_URL}/${id}`, {}, rejectWithValue);
export const getMerchantServices = (params, rejectWithValue) =>
  get(`${SERVICES_BASE_URL}/`, { params }, rejectWithValue);
export const getMerchantServicesById = (id, rejectWithValue) =>
  get(`${SERVICES_BASE_URL}/${id}`, {}, rejectWithValue);
export const getMerchantServicesBookings = () =>
  get(`${SERVICES_BASE_URL}/`, {});
export const getMerchantStoreBranch = () => get(`${STORE_BASE_URL}/`, {});

export const bookMerchantServicesService = (payload, rejectWithValue) =>
  post(`${SERVICES_BASE_URL}/book`, payload, {}, rejectWithValue);
